import { useCallback, useState } from 'react';

const LINE_ANIMATION_DURATION_MS = 300;

export const useTabs = ({
  selectedIndex = '1',
  animatedLineRef,
  containerRef,
}) => {
  const [activeTab, setActiveTab] = useState(selectedIndex);
  const [isAnimating, setIsAnimating] = useState(false);

  // Animate tab underline on active
  const animateLine = useCallback(
    (fromIndex, toIndex) => {
      const tabFrom = document.querySelector(
        `div[data-tabindex="${fromIndex}"]`,
      );
      const tabTo = document.querySelector(`div[data-tabindex="${toIndex}"]`);
      const line = animatedLineRef.current;
      const scrollable = containerRef.current;
      if (tabFrom && tabTo && line && scrollable) {
        setIsAnimating(true);
        // set initial line styles
        line.style.display = 'block';
        line.style.width = `${tabFrom.offsetWidth}px`;
        line.style.transform = `translate(${
          tabFrom.offsetLeft - scrollable.scrollLeft
        }px, 0)`;

        Promise.resolve().then(() => {
          // set final line styles
          line.style.width = `${tabTo.offsetWidth}px`;
          line.style.transform = `translate(${
            tabTo.offsetLeft - scrollable.scrollLeft
          }px, 0)`;
          line.style.transition = `transform ${LINE_ANIMATION_DURATION_MS}ms, width ${LINE_ANIMATION_DURATION_MS}ms`;
        });

        setTimeout(() => {
          // hide line
          line.style.transition = '';
          line.style.display = 'none';
          setIsAnimating(false);
        }, LINE_ANIMATION_DURATION_MS);
      }
    },
    [containerRef, animatedLineRef, setIsAnimating],
  );

  return {
    activeTab,
    setActiveTab,
    isAnimating,
    setIsAnimating,
    animateLine,
  };
};
